module.exports = __webpack_public_path__ + "img/091-slovakia.7af1b1d8.svg";